<div class="usp" data-qa="usp-content-block">
  <div class="usp__title" i18n data-qa="usp-block-title">What's included?</div>
  <ul class="usp__list" data-qa="usp-block-body">
    <li class="usp__list__item">
      <span i18n>Your pick of 40+ schools across 7 countries</span>
    </li>
    <li class="usp__list__item">
      <span i18n>Choose from 16+ courses, junior camps or online lessons</span>
    </li>
    <li class="usp__list__item">
      <span i18n>A selection of accommodation options</span>
    </li>
    <li class="usp__list__item">
      <span i18n>Premium activities for juniors</span>
    </li>
    <li class="usp__list__item">
      <span i18n>Travel extras to compliment your package</span>
    </li>
  </ul>
</div>
